import app from '../../forum/app';
import ComposerBody from './ComposerBody';
import extractText from '../../common/utils/extractText';
import Stream from '../../common/utils/Stream';
import AlertUtil from '../../forum/dianLiang/alertUtil';

/**
 * The `DiscussionComposer` component displays the composer content for starting
 * a new discussion. It adds a text field as a header control so the user can
 * enter the title of their discussion. It also overrides the `submit` and
 * `willExit` actions to account for the title.
 *
 * ### Attrs
 *
 * - All of the attrs for ComposerBody
 * - `titlePlaceholder`
 */
export default class DiscussionComposer extends ComposerBody {
  static initAttrs(attrs) {
    super.initAttrs(attrs);

    attrs.placeholder = attrs.placeholder || extractText(app.translator.trans('core.forum.composer_discussion.body_placeholder'));
    attrs.submitLabel = attrs.submitLabel || app.translator.trans('core.forum.composer_discussion.submit_button');
    attrs.confirmExit = attrs.confirmExit || extractText(app.translator.trans('core.forum.composer_discussion.discard_confirmation'));
    attrs.titlePlaceholder = attrs.titlePlaceholder || extractText(app.translator.trans('core.forum.composer_discussion.title_placeholder'));
    attrs.className = 'ComposerBody--discussion';
    
  }

  oninit(vnode) {
    super.oninit(vnode);

    this.composer.fields.title = this.composer.fields.title || Stream('');
    /**
     * The value of the title input.
     *
     * @type {Function}
     */
    this.title = this.composer.fields.title;
    this.mainImg = Stream('');
    // this.tags = Stream('');
    this.activityTag = Stream(0);
    this.titleSlug = Stream('')
    this.activityTitle = Stream(app.translator.trans('dl-response.forum.discussion.activity'))
    this.adtivityId = Stream(0);

    // Restore draft title if provided by ComposerState.load()
    if (typeof this.attrs.originalTitle === 'string' && !this.title()) {
      this.title(this.attrs.originalTitle);
    }
  }

  headerItems() {
    const items = super.headerItems();

    items.add('title', <h3>{app.translator.trans('core.forum.composer_discussion.title')}</h3>, 100);

    items.add(
      'discussionTitle',
      <h3>
        <input
          className="FormControl"
          bidi={this.title}
          placeholder={this.attrs.titlePlaceholder}
          disabled={!!this.attrs.disabled}
          onkeydown={this.onkeydown.bind(this)}
        />
      </h3>
    );

    return items;
  }

  footItems() {
    const items = super.footItems();

    return items;
  }

  /**
   * Handle the title input's keydown event. When the return key is pressed,
   * move the focus to the start of the text editor.
   *
   * @param {KeyboardEvent} e
   */
  onkeydown(e) {
    if (e.which === 13) {
      // Return
      e.preventDefault();
      this.composer.editor.moveCursorTo(0);
    }

    e.redraw = false;
  }

  hasChanges() {
    return this.title() || this.composer.fields.content();
  }

  /**
   * Get the data to submit to the server when the discussion is saved.
   *
   * @return {Record<string, unknown>}
   */
  data() {
    // let map = this.activityTag();
    // if (typeof this.activityTag() === 'string') {
    //   // 将字符串转换为 JSON 对象
    //   let obj = JSON.parse(this.activityTag());
    //   // 将 JSON 对象转换为 Map 对象
    //   map = new Map(Object.entries(obj));
    // }
    
    return {
      title: this.activityTag() > 0 ? '[' + this.activityTitle() + ']' + this.title() : this.title(),
      content: this.composer.fields.content(),
      mainImg: this.mainImg(),
      // tags: this.tags(),
      activityTag: this.activityTag(),
      activityId: this.adtivityId(),
      isJoin: this.activityTag() > 0
    };
  }

  onsubmit() {
    this.loading = true;

    const data = this.data();
    if (!data.title) {
      this.loading = false;
      AlertUtil.onWarn(app, app.translator.trans('dl-alert.forum.title_empty_warn'));
      return;
    }
  if (!data.content || data.content == '0' || data.content.trim() == "") {
      this.loading = false;
      AlertUtil.onWarn(app, app.translator.trans('dl-alert.forum.content_empty_warn'));
      return;
    }
    //TODO-判断是否存在限制，从限制列表中获取，如果存在强限制，不符合要求需提醒，否则不需提醒
    
    if (data.isJoin) {
      let pkgActivity = app.store.getById('pkgActivityCategories', data.activityId);
      let limitList = JSON.parse(pkgActivity.limitList());
      for (let index = 0; index < limitList.length; index++) {
        const element = limitList[index];
        if (element.strongLimit) {
          if (element.type== '0' && data.content.length < element.param) {
            this.loading = false;
            AlertUtil.onWarn(app, app.translator.trans('dl-discussionComposer.forum.warn_text.numberStr',{count: element.param}));
            return;
          }
          //带图数
          // 使用正则表达式匹配 <img> 标签
          const imgTags = data.content.match(/\[Image description\]/g);

          // 计算匹配到的 <img> 标签数量
          const imgCount = imgTags ? imgTags.length : 0;
          if (element.type== '1' && imgCount < element.param) {
            this.loading = false;
            AlertUtil.onWarn(app, app.translator.trans('dl-discussionComposer.forum.warn_text.imgCount',{count: element.param}));
            return;
          }
          
          //论坛等级
          if (element.type== '2' && app.session.user.userLevel().level() < element.param) {
            this.loading = false;
            AlertUtil.onWarn(app, app.translator.trans('dl-discussionComposer.forum.warn_text.level',{count: element.param}));
            return;
          }
         
        }
      }
    }
    // if (!data.tags) {
    //   this.loading = false;
    //   AlertUtil.onWarn(app, '必须选择板块');
    //   return;
    // }
    
    app.store
      .createRecord('discussions')
      .save(data)
      .then((discussion) => {
        this.composer.hide();
        app.discussions.refresh();
        m.route.set(app.route.discussion(discussion));
      }, this.loaded.bind(this));
  }
}
